module.exports = function() {
  return new Worker(__webpack_public_path__ + "c1a20fbde129887ee586.worker.js");
};